export default () => {

    const onComplianceClick = () => {
        const scriptElement = document.createElement("script");
        scriptElement.src = "https://e6e184d0698d450d9416d42241d4d56f.js.ubembed.com";
        scriptElement.async = false;
        document.body.appendChild(scriptElement);
    };

    return [onComplianceClick];
};